<template>
<!--    <Modal v-model="modalStatus" width="360" :mask-closable="false" :transfer="transferStatus">-->
<!--        <p slot="header" style="color:#f60;text-align:center">-->
<!--            <Icon type="information-circled"></Icon>-->
<!--            <span>{{title}}</span>-->
<!--        </p>-->
<!--        <slot name="body"></slot>-->
<!--        <div slot="footer">-->
<!--            <Button type="error" size="large" long :loading="loadingStatus" @click="yes">{{butTip}}</Button>-->
<!--        </div>-->
<!--    </Modal>-->
    <Modal v-model="modalStatus" width="400" :mask-closable="false" :closable="false" :transfer="transferStatus" :footer-hide="true">
        <div class="all">
            <div class="header">
                <Icon v-if="type ==='error'" class="icon" type="ios-close-circle" size="28" color="#ed4014" />
                <Icon v-if="type ==='warning'" class="icon" type="ios-help-circle" size="28" color="#ff9900" />
                <span class="title">{{title}}</span>
            </div>
            <div class="content">
                <slot name="body"></slot>
            </div>
            <div class="footer">
                <Button type="default"  @click="hide()">取消</Button>
                <Button type="primary" :loading="loadingStatus" @click="yes">{{butTip}}</Button>
            </div>
        </div>
    </Modal>
</template>

<script>
    export default {
        props : {
            type : {
                type : String,
                default : "error",
            },
            title : {
                type: String,
                default: "警告"
            },
            butTip : {
                type: String,
                default: '确定'
            },
            transferStatus : {
                type : Boolean,
                default : true,
            }
        },
        data(){
            return {
                modalStatus : false,
                loadingStatus : false,
            }
        },
        methods:{
            //显示
            show(){
                this.modalStatus = true;
            },
            //隐藏
            hide(){
                this.modalStatus = false;
            },
            //加载
            doLoading(){
                this.loadingStatus = true;
            },
            //停止加载
            noLoading(){
                this.loadingStatus = false;
            },
            //确定按钮点击事件
            yes(){
                this.$emit('callback');
            }
        },
    }
</script>

<style lang="less" scoped>
    @import "./warning.less";
</style>


// WEBPACK FOOTER //
// src/components/warningModal/Warning.vue